var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 4.0265L2.73955 7L8 1.30684L7.24478 0.5L2.73955 5.37497L0.744765 3.21398L0 4.0265Z"}));
}

CheckInline.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
